import { LoaderComponent } from '@dnhb/node_package';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { dispatchMapper, NAVIGATE } from '../wizard/actions';
import Navigation from './Navigation';

function WizardContainer({
  children,
  pages,
  syncing,
  dispatch,
  recalculating,
  navigationDisabled,
  forceStep,
  input,
  sync,
}) {
  const location = useLocation();
  const navigate = useNavigate();
  const currentPageIndex = pages.indexOf(location.state?.page);
  let nextStep = input.next_step_text || 'Volgende stap';
  if (recalculating) nextStep = 'Herberekenen';
  else if (currentPageIndex === pages.length - 2) nextStep = 'Berekenen';
  return (
    <aside>
      {!navigationDisabled && (
        <div className="wrapper">
          <div className="navigation no-tablet-and-smaller">
            <Navigation />
          </div>
        </div>
      )}
      {children}
      <div className="wrapper tablet-and-smaller-only">
        <footer role="presentation" className="mobile">
          <button type="button" onClick={() => sync('show_disclaimer', true)}>
            Disclaimer
          </button>
        </footer>
      </div>
      <nav className="wizard-controls">
        {forceStep === null && !recalculating && currentPageIndex > 0 ? (
          <button
            type="button"
            href="previous"
            tabIndex="-1"
            onClick={e => {
              e.preventDefault();
              dispatch({ type: NAVIGATE, location, navigate, delta: -1 });
            }}
            className="previous"
          >
            Vorige stap
          </button>
        ) : (
          ''
        )}
        {forceStep === null && !input.hide_next_step_button && currentPageIndex < pages.length - 1 ? (
          <button
            type="button"
            href="next"
            onClick={e => {
              e.preventDefault();
              dispatch({
                type: NAVIGATE,
                location,
                navigate,
                delta: recalculating ? recalculating - currentPageIndex : 1,
              });
            }}
            className="next"
          >
            {syncing ? <LoaderComponent show /> : nextStep}
          </button>
        ) : (
          ''
        )}
        {forceStep !== null ? (
          <button
            type="button"
            href="next"
            onClick={e => {
              e.preventDefault();
              dispatch({
                type: NAVIGATE,
                location,
                navigate,
                index: forceStep,
                validate: true,
              });
            }}
            className="next"
          >
            {syncing ? <LoaderComponent show /> : nextStep}
          </button>
        ) : (
          ''
        )}
      </nav>
    </aside>
  );
}

WizardContainer.propTypes = {
  pages: PropTypes.instanceOf(Array).isRequired,
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.instanceOf(Array)]).isRequired,
  dispatch: PropTypes.func.isRequired,
  sync: PropTypes.func,
  recalculating: PropTypes.number,
  syncing: PropTypes.bool.isRequired,
  input: PropTypes.shape(),
  navigationDisabled: PropTypes.bool,
  forceStep: PropTypes.number,
};

WizardContainer.defaultProps = {
  recalculating: 0,
  input: {},
  sync: () => {},
  navigationDisabled: false,
  forceStep: null,
};

export default connect(
  state => ({
    recalculating: state.recalculating,
    settings: state.settings,
    syncing: state.syncing,
    pages: state.pages,
    input: state.input,
  }),
  dispatchMapper
)(WizardContainer);
